// extracted by mini-css-extract-plugin
module.exports = {"value":"Counter_value__NMkfU","value__readOnly":"Counter_value__readOnly__16SAk","btn":"Counter_btn__21afw"};